var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formEdit',{key:_vm.componentKey,attrs:{"mode":_vm.mode,"model":_vm.models},on:{"back":_vm.backToList}})
}
var staticRenderFns = []

export { render, staticRenderFns }